import React from "react";

import { Container, StepDescription, StatusText, Title } from "./styles";
import type { StepStatus } from "../../types";
import ProgressIndicator from "../ProgressIndicator";

interface ProgressStepProps {
  title: string;
  status: StepStatus;
  active: boolean;
  clickable?: boolean;
  onClick?: () => void;
}

const ProgressStep = ({
  status,
  title,
  onClick,
  clickable,
  active,
}: ProgressStepProps) => {
  const handleClick = clickable ? onClick : undefined;

  return (
    <Container clickable={clickable} onClick={handleClick}>
      <ProgressIndicator status={status} active={active} />
      <StepDescription>
        <Title status={status}>{title}</Title>
        <StatusText status={status} active={active} />
      </StepDescription>
    </Container>
  );
};

export default ProgressStep;
